import * as React from 'react';
import { useCallback } from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
} from '../../../../../web/components-v2/Dropdown';
import { useQuotaTeamAutocompleteQuery } from '../../../../queries/Aida/useQuotaTeamAutocomplete';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (item: string | null) => void;
	selected?: string | null;
}

export const QuotaTeamSelect: React.FC<IProps> = ({ onChange, selected }) => {
	const { data: quotaTeams = [], isPending, isError } = useQuotaTeamAutocompleteQuery();

	const handleSelect = useCallback(
		(value: string) => {
			onChange(value);
		},
		[onChange]
	);

	const handleClear = useCallback(() => {
		onChange(null);
	}, [onChange]);

	const isEmpty = !isPending && !isError && quotaTeams.length === 0;
	const triggerLabel = isPending
		? 'Loading quota teams...'
		: isError
			? 'Error loading quota teams'
			: isEmpty
				? 'No quota teams configured'
				: selected
					? `Quota Team: ${selected}`
					: 'Filter by Quota Team';

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[styleSheet.filterDropdownTrigger]} disabled={isPending || isEmpty}>
				{triggerLabel}
			</DropdownSelectTrigger>
			<DropdownContent>
				{!isPending &&
					!isError &&
					quotaTeams.map(team => (
						<DropdownItem key={team} onClick={() => handleSelect(team)}>
							{team}
						</DropdownItem>
					))}
				{selected && <DropdownItem onClick={handleClear}>Clear selection</DropdownItem>}
			</DropdownContent>
		</Dropdown>
	);
};
